import { createContext } from 'react'
import { WillService } from 'types'

export const ServiceTypeContext = createContext<WillService>('all')
